import {
  clearProjectBitmapFont,
  generateProjectBitmapFont,
} from '@/features/bitmap-font/runtime'
import type DataFileMap from '@/model/Resource/DataFileMap'
import type MainProject from '@/model/MainProject'

/**
 * 生成当前工程所需的位图字体。
 * 该用例只负责位图字体与字体虚拟树的副作用，不直接操作 store。
 */
export async function generateWorkspaceBitmapFont(params: {
  project: MainProject
  currentRoot: DataFileMap | null
  extraText?: string
}): Promise<{ root: DataFileMap | null }> {
  const result = await generateProjectBitmapFont({
    project: params.project,
    currentRoot: params.currentRoot,
    extraText: params.extraText,
  })
  return {
    root: result.root,
  }
}

/**
 * 打开工程时清理运行时位图字体缓存，保留普通字体虚拟资源树。
 * 位图字体在测试和发布前按当前文本即时生成，不再从 OSS 读取缓存。
 */
export async function loadWorkspaceBitmapFontAssets(params: {
  project: MainProject
  currentRoot: DataFileMap | null
}): Promise<{
  root: DataFileMap | null
}> {
  return {
    root: await clearProjectBitmapFont({
      project: params.project,
      currentRoot: params.currentRoot,
    }),
  }
}
